import { IGarageVehicleModel } from "../models/garage/garage-vehicle.model";
import { IGarageVehicleDtoModel } from "../models/garage/dto/garage-vehicle-dto.model";
import { IMarqueVehicleDtoModel } from "../models/vehicles/dto/marque-dto.model";

export class GarageVehicleMapper {
    toApplicationModel(model: IGarageVehicleDtoModel): IGarageVehicleModel {
        return {
            id: model.customerVehicleId,
            ...model
        };
    }
    toDtoModel(model: IGarageVehicleModel): IGarageVehicleDtoModel {
        return {
            customerVehicleId: model.id,
            ...model
        };
    }
    toDtoModels(models: IGarageVehicleModel[]): IGarageVehicleDtoModel[] {
        return models.map(model => this.toDtoModel(model));
    }

    toApplicationModels(models: IGarageVehicleDtoModel[]): IGarageVehicleModel[] {
        return models.map(model => this.toApplicationModel(model));
    }

}